export default "__VITE_ASSET__C88L115J__"